import { call, put, takeLatest } from "redux-saga/effects";

import { apiUpdateStatusArticles } from "helpers/api/articles";
import {
  UPDATE_STATUS_ARTICLES,
  actUpdateStatusArticlesFailed,
  actUpdateStatusArticlesSuccess,
} from "store/actions/articles";
import { showToastError, showToastSuccess } from "utils";
import { ARTICLE_LIST_OPTIONS_VALUE } from "pages/articles/constants";

/**
 * Handle get data request and response
 * @param {object} action
 */
function* doUpdateStatus(action) {
  try {
    const response = yield call(apiUpdateStatusArticles, action?.payload);

    if (response?.data) {
      // Call callback action if provided
      yield put(actUpdateStatusArticlesSuccess(response.data));

      if (action.onSuccess) {
        yield action.onSuccess();
      }

      let status = "messages.MSG-USP035";

      if (action.payload?.type === ARTICLE_LIST_OPTIONS_VALUE.DELETE) {
        status = "messages.MSG-USP021";
      }

      if (action.payload?.type === ARTICLE_LIST_OPTIONS_VALUE.HIDDEN) {
        status = "messages.MSG-USP036";
      }

      showToastSuccess(status);
    } else {
      throw new Error(
        response?.error?.reason
          ? `messages.${response?.error?.reason}`
          : response?.error?.message
      );
    }
  } catch (error) {
    yield put(actUpdateStatusArticlesFailed());
    // Call callback action if provided
    showToastError(error?.message);
    if (action.onError) {
      yield action.onError(error);
    }
  }
}

export default function* watchUpdateStatus() {
  yield takeLatest(UPDATE_STATUS_ARTICLES, doUpdateStatus);
}
